// import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: resolve => require(['../components/cardProject/template_cardProject'], resolve),
        redirect: '/GenRedOne',
        children: [
          {
            path: '/GenRedOne',
            name: '券卡查询',
            component: resolve => require(['../components/cardProject/cardSearch'], resolve),
            meta: {
              title: '券卡查询'
            }
          },
          {
            path: '/cardAddress',
            name: '收货信息',
            component: resolve => require(['../components/cardProject/cardAddress'], resolve)
          },
          {
            // 新加路由跳转 跳转到申请送货
            path: '/codeinfoAction!verifyInit',
            name: '升级-送货',
            component: resolve => require(['../components/cardProject/cardDelivery'], resolve),
            meta: {
              title: '券卡提货'
            }
          },
          {
            path: '/GenRedOne/cardDelivery/',
            name: '申请送货',
            component: resolve => require(['../components/cardProject/cardDelivery'], resolve),
            meta: {
              title: '券卡提货'
            }
          },
          {
            path: '/GenRedOne/membercardDelivery/:cardbagcode',
            name: '立即送货',
            component: resolve => require(['../components/cardProject/cardDelivery'], resolve),
            meta: {
              title: '券卡提货'
            }
          },
          {
            path: '/cardSuccess',
            name: '券卡提货订单提交成功',
            component: resolve => require(['../components/cardProject/cardSuccess'], resolve)
          },
          {
            path: '/cardyyAddress',
            name: '预约券卡提货',
            component: resolve => require(['../components/cardProject/cardyyAddress'], resolve)
          },
          {
            path: '/GenRedOne/cardyyDelivery/:cardbagcode',
            name: '立即预约',
            component: resolve => require(['../components/cardProject/cardyyDelivery'], resolve),
            meta: {
              title: '预约自提'
            }
          },
          {
            path: '/cardyyDelivery',
            name: '预约自提',
            component: resolve => require(['../components/cardProject/cardyyDelivery'], resolve)
          },
          {
            path: '/GenRedOne/cardyyDelivery/:storeinfo',
            component: resolve => require(['../components/cardProject/cardyyDelivery'], resolve)
          },
          {
            path: '/cardyySuccess',
            name: '预约自提订单提交成功',
            component: resolve => require(['../components/cardProject/cardyySuccess'], resolve)
          },
          {
            path: '/paymentWX/:orderno',
            name: '订单付款页',
            component: resolve => require(['../components/cardProject/paymentWX'], resolve)
          },
          {
            path: '/paySuccess/:orderno',
            name: '付款成功页',
            component: resolve => require(['../components/cardProject/paySuccess'], resolve)
          },
          {
            path: 'zfbPayConfig',
            name: '支付宝付款页',
            component: resolve => require(['../components/cardProject/zfbPayConfig'], resolve)
          }
        ]
      },
    {
      path: '/500',
      name: '错误页500',
      component: resolve => require(['../components/error/500'], resolve)
    },
    {
      path: '/updatebower',
      name: '游览器更新',
      component: resolve => require(['../components/error/updatebower'], resolve)
    },
    {
      path: '/404',
      name: '错误页404',
      component: resolve => require(['../components/error/404'], resolve)
    },
    {
      path: '*',
      redirect: '/404',
      name: '错误页',
      component: resolve => require(['../components/error/404'], resolve)
    },
    {
      path: '/advise',
      name: '意见建议',
      component: resolve => require(['../components/cardProject/advise'], resolve)
    },
    {
      path: '/orderDetail/:orderno',
      name: '订单详情',
      component: resolve => require(['../components/cardProject/orderDetail'], resolve)
    },
    {
      path: '/goodDetail/:goodscode/:kindcode',
      name: '商品详情',
      component: resolve => require(['../components/goods/goodDetails'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/router/index.js